import { DefaultLayout } from "src/components/Layout"
import Head from "next/head"
import { NextPage } from "next"
import { PropertyNewContainer } from "src/features/properties/components/PropertyNew/PropertyNewContainer"

const PropertyNewPage: NextPage = () => {
  return (
    <DefaultLayout>
      <Head>
        <title>物件の新規登録 | for CS</title>
      </Head>
      <PropertyNewContainer />
    </DefaultLayout>
  )
}

export default PropertyNewPage
